export { ForgottenPasswordPage as default } from '@moonpig/web-customer-account'
